import { Mail, Clock, Phone, MapPin } from "lucide-react";

export default function Request() {
    return (
        <div data-testid="request-page">
            <section className="pt-20 pb-16 md:pt-28 md:pb-12">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <p className="overline">Ajánlatkérés</p>
                    <h1
                        data-testid="request-heading"
                        className="font-serif mt-5 text-5xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-tight text-[#2C2724] max-w-4xl"
                    >
                        Vegye fel velünk
                        <br />
                        <span className="italic text-[#C98A4B]">
                            a kapcsolatot.
                        </span>
                    </h1>
                    <p className="mt-10 text-lg text-[#5C534D] max-w-2xl leading-relaxed">
                        Írjon nekünk egy e-mailt a{" "}
                        <a
                            href="mailto:baupakskft@gmail.com"
                            className="font-medium text-[#4A3728] underline decoration-[#C98A4B]/60 underline-offset-4 hover:decoration-[#C98A4B]"
                        >
                            baupakskft@gmail.com
                        </a>{" "}
                        címre — 48 órán belül felvesszük Önnel a
                        kapcsolatot.
                    </p>
                </div>
            </section>

            <section className="pb-24 md:pb-36">
                <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    {/* Left: instructions card */}
                    <div className="lg:col-span-7">
                        <div className="bg-[#F3EBE1] border border-[#4A3728]/15 p-8 md:p-12">
                            <Mail
                                size={32}
                                strokeWidth={1.5}
                                className="text-[#C98A4B]"
                            />
                            <h2 className="font-serif text-3xl md:text-4xl mt-6 text-[#2C2724] leading-tight">
                                Mit írjon meg nekünk?
                            </h2>
                            <p className="mt-6 text-[#5C534D] leading-relaxed">
                                Írja meg nekünk, miben segíthetünk:
                                épületasztalos-ipari gyártás,
                                kivitelezési feladat vagy más kapcsolódó
                                szakipari igény.
                            </p>
                            <p className="mt-4 text-[#5C534D] leading-relaxed">
                                Adja meg elérhetőségét és röviden az
                                elképzelést, és keresni fogjuk a
                                részletekkel kapcsolatban.
                            </p>

                            <a
                                href="mailto:baupakskft@gmail.com?subject=Aj%C3%A1nlatk%C3%A9r%C3%A9s%20%E2%80%94%20BAU-Paks%20Kft."
                                data-testid="request-email-cta"
                                className="inline-flex items-center gap-3 mt-10 px-8 py-4 bg-[#4A3728] text-[#F9F6F0] text-sm font-semibold tracking-wide hover:bg-[#2C2724] transition-colors duration-500"
                            >
                                <Mail size={16} />
                                E-mail írása —
                                baupakskft@gmail.com
                            </a>

                            <p className="mt-6 text-xs text-[#5C534D]">
                                Válasz: legkésőbb 48 órán belül.
                            </p>
                        </div>
                    </div>

                    {/* Right: contact details */}
                    <aside className="lg:col-span-5 space-y-10">
                        <div>
                            <p className="overline text-[#4A3728]">
                                Vagy hívjon közvetlenül
                            </p>
                            <ul className="mt-6 space-y-5">
                                <li className="flex items-start gap-4">
                                    <Phone
                                        size={18}
                                        className="mt-1 text-[#C98A4B] flex-shrink-0"
                                    />
                                    <div>
                                        <p className="text-xs uppercase tracking-[0.2em] text-[#5C534D]">
                                            Telefon
                                        </p>
                                        <a
                                            href="tel:+36202100472"
                                            data-testid="contact-phone"
                                            className="font-serif text-2xl text-[#2C2724] hover:text-[#C98A4B] transition-colors"
                                        >
                                            +36 20 210-0472
                                        </a>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <Mail
                                        size={18}
                                        className="mt-1 text-[#C98A4B] flex-shrink-0"
                                    />
                                    <div>
                                        <p className="text-xs uppercase tracking-[0.2em] text-[#5C534D]">
                                            E-mail
                                        </p>
                                        <a
                                            href="mailto:baupakskft@gmail.com"
                                            data-testid="contact-email"
                                            className="font-serif text-2xl text-[#2C2724] hover:text-[#C98A4B] transition-colors"
                                        >
                                            baupakskft@gmail.com
                                        </a>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <MapPin
                                        size={18}
                                        className="mt-1 text-[#C98A4B] flex-shrink-0"
                                    />
                                    <div>
                                        <p className="text-xs uppercase tracking-[0.2em] text-[#5C534D]">
                                            Telephely
                                        </p>
                                        <a
                                            href="https://www.google.com/maps/search/?api=1&query=7030+Paks+Tolnai+%C3%BAt+26"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-testid="contact-address"
                                            className="font-serif text-2xl text-[#2C2724] hover:text-[#C98A4B] transition-colors block"
                                        >
                                            7030 Paks, Tolnai út 26.
                                        </a>
                                        <p className="mt-1 text-sm text-[#5C534D]">
                                            Látogatás előzetes
                                            egyeztetéssel.
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="border-t border-[#4A3728]/20 pt-8">
                            <div className="flex items-center gap-2">
                                <Clock
                                    size={14}
                                    className="text-[#C98A4B]"
                                />
                                <p className="overline text-[#4A3728]">
                                    Nyitvatartás
                                </p>
                            </div>
                            <ul className="mt-4 text-sm text-[#5C534D] space-y-1">
                                <li className="flex justify-between">
                                    <span>Hétfő – Péntek</span>
                                    <span className="text-[#2C2724]">
                                        8:00 – 16:00
                                    </span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Szombat – Vasárnap</span>
                                    <span>Zárva</span>
                                </li>
                            </ul>
                        </div>
                    </aside>
                </div>
            </section>
        </div>
    );
}
